export const config = {
    modelName: 'login',
    formName: "login",
} as const;
